import { callFunctionGet } from "./client";

export interface SessionCapabilities {
  read_members: boolean;
  create_members: boolean;
  write_members: boolean;
  write_departments: boolean;
  reset_password: boolean;
  read_audit: boolean;
  manage_access: boolean;
  request_mfa_recovery: boolean;
  approve_mfa_recovery: boolean;
  read_payments?: boolean;
  record_payment?: boolean;
  adjust_payment?: boolean;
}

export interface SessionContext {
  member_id: string | null;
  capabilities: SessionCapabilities;
}

export function getSessionContext(accessToken: string): Promise<SessionContext> {
  return callFunctionGet<SessionContext>("auth-session-context", {}, { accessToken });
}
